import { NavigationGuard } from 'vue-router'
import bags from '@/bags'

const onlyGuest: NavigationGuard = async (to, from, next) => {
  if (bags.my.getter.isGuest) next()
  else next('/')
}

export default onlyGuest
